// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_3r1","cls2":"ExportFormatModal-cls2_sRg ExportFormatModal-cls1_3r1"};